import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { RECENT_ACTIVITY } from 'constants/lsqaConstants';
import Spinner from 'components/MainSpinner/MainSpinner';
import { listItemSpinnerConfig } from 'constants/Spinner';
import classes from './ActivityFeed.module.scss';
import ActivityFeedListItem from './ActivityFeedListItem';

class ActivityFeed extends React.Component {
  renderMissed = () => (
    <span className={classes.missedRecentsLabel}>
      <FormattedMessage
        id="components.activityFeed.missedTitle"
        defaultMessage="{totalMissed} missed"
        values={{ totalMissed: this.props.totalMissedCalls }}
      />
    </span>);

  renderSpinner = () => (
    <div>
      <Spinner
        config={listItemSpinnerConfig}
      />
    </div>
  );

  renderFeed = () => (
    <ul className={classes.recentsListNew} {...RECENT_ACTIVITY}>
      { this.props.callHistory.map((call, index) =>
        (<ActivityFeedListItem
          call={call}
          createContact={this.props.createContact}
          handleAudioCall={this.props.handleAudioCall}
          handleChat={this.props.handleChat}
          handleDeleteSelected={this.props.handleDeleteSelected}
          handleVideoCall={this.props.handleVideoCall}
          hideContacts={this.props.hideContacts}
          hideMeetings={this.props.hideMeetings}
          hideRooms={this.props.hideRooms}
          isChatEnabled={this.props.isChatEnabled}
          key={`call-${index}-${call.id}`}
          pushRoute={this.props.history.push}
          shortlist
        />))
      }
    </ul>
  );

  renderEmptyMessage = () => (
    <div className={classes.emptyRecentsList}>
      <FormattedMessage
        id="components.activityFeed.recentsEmpty"
        description="Empty Recents Message"
        defaultMessage="Your call history and any missed calls will appear here."
      />
    </div>
  );
  // Used to avoid code duplication.
  renderEmptyOrList = () => (
    <div className={classes.recentsContainer}>
      {this.props.callHistory.length ? this.renderFeed() : this.renderEmptyMessage()}
    </div>
  );

  render() {
    return (
      <div className={classes.activityFeedContainer}>
        <div className={classes.headerLabel}>
          <FormattedMessage
            id="components.activityFeed.label"
            description="Activity Feed Label"
            defaultMessage="Activity"
          />
        </div>
        <div className={classes.recentsLabelContainer}>
          <div className={classes.recentsLabel}>
            <FormattedMessage
              id="components.activityFeed.recentsLabel"
              description="Recents label"
              defaultMessage="Recents"
            />
          </div>
          {!!this.props.totalMissedCalls && this.renderMissed()}
        </div>
        <hr />
        {this.props.isFeedLoaded ? this.renderEmptyOrList() : this.renderSpinner()}
        <div className={classes.bottomFade} />
      </div>
    );
  }
}

ActivityFeed.propTypes = {
  callHistory: PT.array,
  createContact: PT.func,
  handleAudioCall: PT.func,
  handleChat: PT.func,
  handleDeleteSelected: PT.func.isRequired,
  handleVideoCall: PT.func,
  hideContacts: PT.bool,
  hideMeetings: PT.bool,
  hideRooms: PT.bool,
  isChatEnabled: PT.bool,
  isFeedLoaded: PT.bool,
  totalMissedCalls: PT.number
};

export default ActivityFeed;
